import { NotificationService } from "../../services/notification.service";
import { Component, Input } from "@angular/core";
import { Router } from '@angular/router';
import { takeUntil } from "rxjs/operators";
import { OverlayService } from "../../services/overlay.service";
import { Store } from "../../store";
import { AlertConfirmData, defaultAlertConfirmData } from "../../data-types/alert-data";
import { AlertService } from "../../services/alert.service";
import { Notification } from 'src/app/models/notification.model';
import { Subject } from "rxjs";

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent
{
    @Input() showRead = false;
    deviceType$ = this.store.select<string>('deviceType');
    notifications$ = this.store.select<Notification[]>('notifications');
    private routeMap;

    private destroy$ = new Subject();

    constructor(
        private overlayService: OverlayService,
        private store: Store,
        private notificationService: NotificationService,
        private alertService: AlertService,
        private router: Router,
    )
    {
        this.notificationService
            .init()
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => this.routeMap = data.data.routeMap?.public);
    }

    ngOnDestroy(): void
    {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public delete(notification: Notification, $event: MouseEvent)
    {
        $event.stopPropagation();
        const notifications = this.store.selectForLocal('notifications');
        notifications.data = notifications.data.filter(item => item.id !== notification.id);
        notifications.unread--;
        this.store.set('notifications', notifications);
        this.notificationService.delete(notification.id).subscribe();
    }

    markAllAsRead()
    {
        this.alertService
            .confirm({
                    ...defaultAlertConfirmData,
                    title: 'Are you Sure',
                    confirmText: "Yes",
                    confirmClass: "btn-danger",
                    confirmCb: this.clearNotifications.bind(this)
                } as AlertConfirmData
            );
    }

    private clearNotifications()
    {
        const user = this.store.selectForLocal('user');
        this.notificationService.markAllAsRead(user.id).subscribe((res) =>
        {
            if (res.data) {
                this.store.set('notifications', {
                    ...this.store.selectForLocal('notifications'),
                    unread: 0
                });

                this.overlayService.closeAll();
            }
        });
    }

    getNotificationRoute(notification): string | null
    {
        return this.routeMap[notification.type];
    }

    public notificationClickHandler(notification: Notification): void
    {
        const routeString = this.getNotificationRoute(notification);

        const commands = routeString.split('/').map(item => {
            if (item[0] === '$') {
                return notification[item.slice(1)];
            }
            return item;
        });
        if (commands) {
            this.router.navigate(commands);
        }
    }
}
